/* Widget de vídeo de producto (Cefiba)
   Lightbox grande -> mini-reproductor flotante arrastrable, con un único iframe de YouTube
   que se reposiciona (left/top/width/height) para que la reproducción no se corte. */
(function () {
  'use strict';

  function init() {
    var trigger = document.querySelector('[data-cefiba-video]');
    var vp = document.querySelector('[data-cefiba-vp]');
    if (!trigger || !vp) return;

    // Sacar el reproductor del flujo (a <body>) para que position:fixed no quede atrapado.
    if (vp.parentNode !== document.body) document.body.appendChild(vp);

    var videoId = trigger.getAttribute('data-video-id');
    var frame = vp.querySelector('.cefiba-vp__frame');
    var ytTarget = vp.querySelector('#cefiba-vp-yt');
    var thumbBtn = trigger.querySelector('.cefiba-vw__thumb');
    var grab = vp.querySelector('[data-cefiba-grab]');

    var player = null;
    var apiRequested = false;
    var openGuardUntil = 0;
    var MARGIN = 18;
    var miniLeft = null, miniTop = null;

    /* ---------- YouTube IFrame API ---------- */
    function ensureApi(cb) {
      if (window.YT && window.YT.Player) { cb(); return; }
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prev === 'function') { try { prev(); } catch (e) {} }
        cb();
      };
      if (!apiRequested) {
        apiRequested = true;
        var s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(s);
      }
    }
    function createPlayer() {
      player = new YT.Player(ytTarget, {
        videoId: videoId,
        playerVars: { autoplay: 1, rel: 0, modestbranding: 1, playsinline: 1 },
        events: { onReady: function (e) { try { e.target.playVideo(); } catch (x) {} } }
      });
    }
    function play() {
      ensureApi(function () {
        if (!player) createPlayer();
        else { try { player.playVideo(); } catch (e) {} }
      });
    }

    /* ---------- geometría ---------- */
    function vw() { return window.innerWidth || document.documentElement.clientWidth; }
    function vh() { return window.innerHeight || document.documentElement.clientHeight; }
    function setRect(w, h, left, top) {
      frame.style.width = Math.round(w) + 'px';
      frame.style.height = Math.round(h) + 'px';
      frame.style.left = Math.round(left) + 'px';
      frame.style.top = Math.round(top) + 'px';
    }
    function layoutOpen() {
      var w = Math.min(960, vw() * 0.92);
      var h = w * 9 / 16;
      var maxH = vh() * 0.86;
      if (h > maxH) { h = maxH; w = h * 16 / 9; }
      setRect(w, h, (vw() - w) / 2, (vh() - h) / 2);
    }
    function layoutMini(keepPos) {
      var w = Math.min(340, vw() * 0.82);
      var h = w * 9 / 16;
      if (!keepPos || miniLeft === null) {
        miniLeft = vw() - w - MARGIN;
        miniTop = vh() - h - MARGIN;
      }
      miniLeft = Math.max(MARGIN, Math.min(miniLeft, vw() - w - MARGIN));
      miniTop = Math.max(MARGIN, Math.min(miniTop, vh() - h - MARGIN));
      setRect(w, h, miniLeft, miniTop);
    }

    /* ---------- estados ---------- */
    function openLightbox() {
      var wasHidden = vp.hidden;
      vp.hidden = false;
      vp.setAttribute('aria-hidden', 'false');
      vp.classList.remove('is-mini');
      vp.classList.add('is-open');
      if (wasHidden) {
        vp.classList.add('is-instant');
        layoutOpen();
        void frame.offsetWidth; /* reflow: aparece centrado sin deslizarse */
        vp.classList.remove('is-instant');
      } else {
        layoutOpen();
      }
      openGuardUntil = Date.now() + 480;
      play();
    }
    function minimize() {
      if (!vp.classList.contains('is-open')) return;
      vp.classList.remove('is-open');
      vp.classList.add('is-mini');
      layoutMini(false);
    }
    function expand() {
      vp.classList.remove('is-mini');
      vp.classList.add('is-open');
      layoutOpen();
      openGuardUntil = Date.now() + 480;
    }
    function close() {
      vp.classList.remove('is-open', 'is-mini', 'is-dragging');
      vp.hidden = true;
      vp.setAttribute('aria-hidden', 'true');
      if (player) { try { player.stopVideo(); } catch (e) {} }
    }

    /* ---------- listeners ---------- */
    if (thumbBtn) thumbBtn.addEventListener('click', openLightbox);
    var minBtn = vp.querySelector('[data-cefiba-min]');
    var expBtn = vp.querySelector('[data-cefiba-expand]');
    var closeBtn = vp.querySelector('[data-cefiba-close]');
    var backdrop = vp.querySelector('[data-cefiba-backdrop]');
    if (minBtn) minBtn.addEventListener('click', minimize);
    if (expBtn) expBtn.addEventListener('click', expand);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', minimize);

    window.addEventListener('scroll', function () {
      if (vp.classList.contains('is-open') && Date.now() > openGuardUntil) minimize();
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (vp.classList.contains('is-open')) layoutOpen();
      else if (vp.classList.contains('is-mini')) layoutMini(true);
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && !vp.hidden) close();
    });

    /* ---------- arrastre + clic-para-ampliar (modo mini) ---------- */
    var dragging = false, moved = false, startX = 0, startY = 0, startLeft = 0, startTop = 0;
    function point(e) { return e.touches && e.touches[0] ? e.touches[0] : e; }
    function onDown(e) {
      if (!vp.classList.contains('is-mini')) return;
      var p = point(e);
      dragging = true; moved = false;
      startX = p.clientX; startY = p.clientY;
      startLeft = miniLeft; startTop = miniTop;
      vp.classList.add('is-dragging');
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend', onUp);
    }
    function onMove(e) {
      if (!dragging) return;
      var p = point(e);
      var dx = p.clientX - startX, dy = p.clientY - startY;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
      if (moved && e.cancelable) e.preventDefault();
      miniLeft = startLeft + dx;
      miniTop = startTop + dy;
      layoutMini(true);
    }
    function onUp() {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onUp);
      vp.classList.remove('is-dragging');
      var wasMoved = moved;
      dragging = false; moved = false;
      if (!wasMoved) expand(); /* clic sin arrastrar -> ampliar */
    }
    if (grab) {
      grab.addEventListener('mousedown', onDown);
      grab.addEventListener('touchstart', onDown, { passive: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
